import { Container } from '@material-ui/core';
import useLanguageStore from '@stores/languageStore';
import { useTranslation } from 'react-i18next';
import SEOHead from '../../components/SEOHead';
import SectionHeader from '../../components/SectionHeader';

const AboutPage = () => {
  const { t } = useTranslation();
  const { language } = useLanguageStore();
  const isRtl = language === 'he';

  const contentParagraphs = [
    t('about.content.paragraph1'),
    t('about.content.paragraph2'),
    t('about.content.paragraph3'),
    t('about.content.paragraph4'),
    t('about.content.paragraph5'),
    t('about.content.paragraph6'),
  ];

  const servicesParagraphs = [
    t('about.services.paragraph1'),
    t('about.services.paragraph2'),
    t('about.services.paragraph3'),
    t('about.services.paragraph4'),
    t('about.services.paragraph5'),
    t('about.services.paragraph6'),
  ];

  return (
    <div
      className={`min-h-[calc(100vh-64px)] py-20 sm:py-32 max-w-[100vw] overflow-x-hidden ${
        isRtl ? 'rtl' : 'ltr'
      }`}
    >
      <SEOHead titleKey="about.meta.title" descriptionKey="about.meta.description" />
      <Container maxWidth="lg" className="px-4 sm:!px-32">
        {/* About Section */}
        <SectionHeader title={t('about.title')} className="mb-12" titleWeight="800" component="h1" />

        <div className={`leading-relaxed text-base ${isRtl ? 'text-right' : 'text-left'}`}>
          {contentParagraphs.map((paragraph, index) => (
            <p
              key={`about-content-${index}`}
              className={index < 2 ? 'font-bold' : ''}
              dangerouslySetInnerHTML={{ __html: paragraph }}
            />
          ))}
        </div>

        {/* Services Section */}
        <SectionHeader
          title={t('about.services.title')}
          className="mt-20 mb-12"
          titleWeight="800"
        />

        <div className={`leading-relaxed text-base ${isRtl ? 'text-right' : 'text-left'}`}>
          {servicesParagraphs.map((paragraph, index) => (
            <p
              key={`about-services-${index}`}
              className={index < 2 ? 'font-bold' : ''}
              dangerouslySetInnerHTML={{ __html: paragraph }}
            />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default AboutPage;
